/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type {
  CardBackResponse,
  CardBackReview,
  CardBackReviewsSummary,
  CardBackSupplementalDescription,
  Listables,
} from '@zcode/state-type'

export const appendListableData = (listables: Listables, cardBackResponse: CardBackResponse) => {
  if (listables && 'listables' in listables && Object.keys(cardBackResponse).length) {
    for (const listable of listables.listables) {
      const grouIdString = String(listable.groupId)
      let review: CardBackReview | undefined
      let supplementalDescription: CardBackSupplementalDescription | undefined
      let reviewsSummary: CardBackReviewsSummary | undefined
      if (cardBackResponse[grouIdString]) {
        review = cardBackResponse[grouIdString].review
        supplementalDescription = cardBackResponse[grouIdString].supple_description
        reviewsSummary = cardBackResponse[grouIdString].reviews_summary
      }
      listable._data.review = review
      listable._data.reviews_summary = reviewsSummary
      listable._data.supple_description = supplementalDescription
    }
  }

  return listables
}
